import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PdfService {
  private pdfMake: any;
  private fonts: any;

  constructor() {}

  private async loadPdfMake() {
    if (!this.pdfMake) {
      this.pdfMake = (await import('pdfmake/build/pdfmake')).default;
    }

    // vfs_fonts'u yükle
    const pdfFonts = await import('pdfmake/build/vfs_fonts');
    this.fonts = pdfFonts.default;

    // fontları tanımla
    this.pdfMake.fonts = {
      Roboto: {
        normal: 'Roboto-Regular.ttf',
        bold: 'Roboto-Medium.ttf',
        italics: 'Roboto-Italic.ttf',
        bolditalics: 'Roboto-MediumItalic.ttf'
      }
    };
  }

  public async generatePdf(docDefinition: any) {
    await this.loadPdfMake();
    this.pdfMake.createPdf(docDefinition, undefined, undefined, this.fonts).open();
  }
  
  public async generatePdfBase64(docDefinition: any): Promise<string> {
    await this.loadPdfMake();

    return new Promise((resolve, reject) => {
      this.pdfMake
        .createPdf(docDefinition, undefined, undefined, this.fonts)
        .getBase64((base64: string) => {
          resolve(base64); 
        });
    });
  }

}